// extracted by mini-css-extract-plugin
module.exports = {"ApplyConstract":"index-module_ApplyConstract_1pl3E","content":"index-module_content_2AAmF","title":"index-module_title_2809w","paragraph":"index-module_paragraph_2QY3l"};